import styled from "styled-components";
import Dialog from "../../dialog/dialog";

export const SaveFilterModalStyled = styled(Dialog)`
  width: 25%;
  margin: 0 !important;
  button {
    color: #301d35 !important;
    border: 1px solid #301d35;
  }
  .dialog-body {
    padding: 16px;
  }
  button:hover {
    background-color: #dedafb !important;
  }
  .head {
    display: flex;
    align-items: flex-end;
    padding-bottom: 16px;
  }
  .form {
    display: grid;
    gap: 16px;
  }
`;
